export const shadows = {
    '2xl': {
        value: '0px 4px 8px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px 0px rgba(0, 0, 0, 0.12)',
    },
    searchBar: {
        value: '0px 0px 32px 0px rgba(0, 0, 0, 0.15)',
    },
    sticky: {
        value: '0 0 12px rgba(0, 0, 0, 0.06)',
    },
};
